import Game from 'Game';
import { IAPReward } from 'Utility/RewardHelper';
import { ProductId } from 'Utility/Product';
import { report } from 'report';
import { GameActions } from 'State/Game/GameActions';
import { getIAPRewards } from 'Utility/Helpers/IAP/IAPRewards';
import { IPurchaseConsumptionData } from 'State/Player/IAP/IAPStateHelper';

export async function handleIAP() {
    // const supported: boolean = await Game.sdk.waitForPaymentsEnabled();
    // if (!supported) return;

    const fetchCatalogSucceed = await Game.sdk.fetchCatalog();
    if (!fetchCatalogSucceed) return;

    const unconsumedPurchases = await Game.sdk.resolveUnconsumedPurchases();

    // TODO: what if `ProductId` doesn't match?
    const IAPRewardData: IAPReward[] = getIAPRewards();
    const iapRewardById: { [key in ProductId]?: IAPReward } = Object.fromEntries(IAPRewardData.map(r => [r.id, r]));

    const filteredRewards: IPurchaseConsumptionData[] = unconsumedPurchases
        .map((productPurchased: FBInstant.Purchase) => {
            return { productReward: iapRewardById[productPurchased.productID as ProductId], productPurchased };
        })
        .filter(purchaseData => Boolean(purchaseData.productReward));

    const failedIds = unconsumedPurchases.filter((id: ProductId) => !iapRewardById[id]);

    if (failedIds.length > 0) {
        report('Failed to find reward data for unconsumed purchases', {
            tags: {
                failedIds: `"${failedIds.join('","')}"`,
            },
            fingerprint: 'MissingRewardData4UnconsumedPurchase',
        });
    }

    GameActions.enableIAP(filteredRewards);
}
